var map = {
	"./archive.svg": 39363,
	"./arrow-right.svg": 76415,
	"./arrow.svg": 57190,
	"./backpack-fill.svg": 44673,
	"./bank.svg": 73209,
	"./book-half.svg": 67498,
	"./building-fill.svg": 4223,
	"./buildings-fill.svg": 18420,
	"./bullseye-arrow.svg": 73002,
	"./calendar2-month-fill.svg": 56182,
	"./cancelation.svg": 45060,
	"./canvas-full.svg": 51135,
	"./canvas.svg": 97095,
	"./chart.svg": 43237,
	"./chat-dots-fill.svg": 54280,
	"./chevron.svg": 66180,
	"./classroom.svg": 62764,
	"./clipboard-check-fill.svg": 39266,
	"./close.svg": 35837,
	"./connect-1.svg": 53593,
	"./connect-2.svg": 27594,
	"./delete.svg": 90930,
	"./discount.svg": 8574,
	"./eg-google.svg": 3441,
	"./eg-stepper-step-active.svg": 81149,
	"./eg-stepper-step.svg": 64102,
	"./emoji-smile-fill.svg": 92778,
	"./envelope-paper-fill.svg": 1460,
	"./essaygrader.svg": 7445,
	"./eye.svg": 34426,
	"./flags/au.svg": 88457,
	"./flags/be.svg": 75824,
	"./flags/br.svg": 83327,
	"./flags/ca.svg": 48083,
	"./flags/cn.svg": 9540,
	"./flags/de.svg": 66414,
	"./flags/es.svg": 5331,
	"./flags/fr.svg": 82043,
	"./flags/gr.svg": 65964,
	"./flags/ie.svg": 36289,
	"./flags/is.svg": 31551,
	"./flags/it.svg": 2176,
	"./flags/jp.svg": 38357,
	"./flags/mx.svg": 77680,
	"./flags/uk.svg": 6155,
	"./flags/us.svg": 26243,
	"./flags/za.svg": 97460,
	"./flask.svg": 98356,
	"./flexibility.svg": 89228,
	"./folder-fill.svg": 4983,
	"./folder.svg": 30811,
	"./folders.svg": 44082,
	"./fr.svg": 89551,
	"./globe-europe-africa.svg": 66188,
	"./google-classroom.svg": 46144,
	"./google.svg": 3486,
	"./keep-your-data.svg": 35109,
	"./math.svg": 71161,
	"./medal.svg": 87536,
	"./money_saved.svg": 67149,
	"./mortarboard-fill.svg": 30586,
	"./other.svg": 40283,
	"./palette-fill.svg": 58974,
	"./party.svg": 75569,
	"./pause-subscription.svg": 11991,
	"./people-fill.svg": 62136,
	"./plus.svg": 24491,
	"./puzzle-fill.svg": 24839,
	"./save-costs.svg": 31649,
	"./save_time.svg": 99144,
	"./school.svg": 88631,
	"./schoology.svg": 20170,
	"./seedling.svg": 90644,
	"./star.svg": 40815,
	"./stars-white.svg": 59482,
	"./stars.svg": 22414,
	"./switch-plan.svg": 67025,
	"./three-dots.svg": 81462,
	"./upload.svg": 50600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;